import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dispersion-tabs',
  templateUrl: './dispersion-tabs.component.html',
  styleUrls: ['./dispersion-tabs.component.css']
})
export class DispersionTabsComponent implements OnInit {
  tabs = [];
  showContentTab = true;

  constructor(
    private router: Router
  ) {
    this.tabs.push({name: 'request',  label: 'Solicitudes', route: 'request', index: 0});
    this.tabs.push({name: 'pending',  label: 'Pendientes',  route: 'pending', index: 1});
    this.tabs.push({name: 'history',  label: 'Historial',   route: 'history', index: 2});
    this.tabs.push({name: 'partials', label: 'Parciales',   route: 'partial', index: 3});
  }

  ngOnInit() {
  }

  newDispersion() {
    this.router.navigate(['/dash/dispersions/new/']);
  }

  onTabChange(tab) {
    this.showContentTab = false;
    console.log('Tab Change !!');
    console.log(tab);
    console.log(tab.addedItems[0]);
    setTimeout(() => {
      this.showContentTab = true;
    },100)
    /*
    this.router.navigate(['list',tab.addedItems[0].route], {
      relativeTo: this.activatedRoute
    });
    */
  }

}
